import React from 'react';
import { Route, Switch, Link } from 'react-router-dom';
import Loadable from 'react-loadable';
import Iconfont from '../pages/components/Iconfont';
import Loading from './Loading';
import { Menu } from 'antd';
import './Layout.css';

// 按需加载路由组件
/*
 * 项目导航栏
 */
// ---------------我的项目
// 项目列表
const MyProject = Loadable({
  loader: () => import('../pages/agent/MyProject/ProjectList'),
  loading: Loading
});
// 新建项目
const NewProject = Loadable({
  loader: () => import('../pages/agent/MyProject/NewProject'),
  loading: Loading
});
// 项目详情
const ProjectDetail = Loadable({
  loader: () => import('../pages/agent/MyProject/ProjectDetail'),
  loading: Loading
});
// 投资协议
const InvestAgreement = Loadable({
  loader: () =>
    import('../pages/agent/MyProject/InvestConfirmAgreement/InvestAgreement'),
  loading: Loading
});
// 投资份额
// const InvestShare = Loadable({
//   loader: () =>
//     import('../pages/agent/MyProject/InvestConfirmAgreement/InvestShare'),
//   loading: Loading
// });
// ---------------我的企业
const MyEnterprise = Loadable({
  loader: () => import('../pages/agent/MyEnterprise/enterpriseList'),
  loading: Loading
});
//-------------新增企业修改企业
const EnterpriseForm = Loadable({
  loader: () => import('../pages/agent/MyEnterprise/enterpriseForm'),
  loading: Loading
});

// ---------------关于我们
const AboutUs = Loadable({
  loader: () => import('../pages/agent/aboutUs'),
  loading: Loading
});

/* 账户中心 */
const AccountCenter = Loadable({
  loader: () => import('../pages/agent/AccountCenter'),
  loading: Loading
});

/* 账户中心-充值 */
const Recharge = Loadable({
  loader: () => import('../pages/agent/AccountCenter/Recharge'),
  loading: Loading
});

/* 账户中心-支付等待 */
const RechargeCallBack = Loadable({
  loader: () => import('../pages/agent/AccountCenter/RechargeCallBack'),
  loading: Loading
});

/* 转让列表 */
const TransferList = Loadable({
  loader: () => import('../pages/agent/TransferList'),
  loading: Loading
});

/* 回收记录 */
const RepurchaseList = Loadable({
  loader: () => import('../pages/agent/RepurchaseList'),
  loading: Loading
});

/* 出售记录 */
const SellList = Loadable({
  loader: () => import('../pages/agent/SellList'),
  loading: Loading
});

/* 开票记录 */
const TicketList = Loadable({
  loader: () => import('../pages/agent/TicketList'),
  loading: Loading
});

const iconStyle = {
  fontSize: 18
};
class Layout extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedKeys: 'myProject'
    };
  }
  componentDidMount() {
    const { location } = this.props;
    const secondLevelMenu = location.pathname.split('/')[2];
    this.setState({
      selectedKeys: secondLevelMenu
    });
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const secondLevelMenu = nextProps.location.pathname.split('/')[2];
    this.setState({
      selectedKeys: secondLevelMenu
    });
  }
  menuClick = menuObj => {
    this.setState({
      selectedKeys: menuObj.key
    });
  };
  render() {
    const { match } = this.props;

    return (
      <div className="layout">
        <div className="content-wrap">
          <div className="side">
            <div className="pic">
              <img src={require('../images/logo.png')} alt="" />
            </div>
            <Menu
              selectedKeys={[this.state.selectedKeys]}
              onClick={this.menuClick}
              theme="dark"
              mode="inline"
            >
              <Menu.Item key="myProject">
                <Link to={`${match.path}/myProject`}>
                  <Iconfont style={iconStyle}>&#xe64a;</Iconfont>
                  <span>我的项目</span>
                </Link>
              </Menu.Item>

              <Menu.Item key="transferList">
                <Link to={`${match.path}/transferList`}>
                  <Iconfont style={iconStyle}>&#xe64a;</Iconfont>
                  <span>转让列表</span>
                </Link>
              </Menu.Item>

              <Menu.Item key="repurchaseList">
                <Link to={`${match.path}/repurchaseList`}>
                  <Iconfont style={iconStyle}>&#xe64a;</Iconfont>
                  <span>回收记录</span>
                </Link>
              </Menu.Item>

              <Menu.Item key="sellList">
                <Link to={`${match.path}/sellList`}>
                  <Iconfont style={iconStyle}>&#xe64a;</Iconfont>
                  <span>出售记录</span>
                </Link>
              </Menu.Item>

              <Menu.Item key="ticketList">
                <Link to={`${match.path}/ticketList`}>
                  <Iconfont style={iconStyle}>&#xe64a;</Iconfont>
                  <span>开票记录</span>
                </Link>
              </Menu.Item>

              <Menu.Item key="myEnterprise">
                <Link to={`${match.path}/myEnterprise`}>
                  <Iconfont style={iconStyle}>&#xe60c;</Iconfont>
                  <span>我的企业</span>
                </Link>
              </Menu.Item>


            </Menu>
          </div>
          <div className="content">
            <Switch>
              {/* 项目列表---我的项目 */}
              <Route
                exact
                path={`${match.path}/myProject`}
                component={MyProject}
              />
              {/* 新建项目---我的项目 */}
              <Route
                exact
                path={`${match.path}/myProject/newProject`}
                component={NewProject}
              />
              {/* 项目详情---我的项目 */}
              <Route
                exact
                path={`${match.path}/myProject/projectDetail/:projectId`}
                component={ProjectDetail}
              />
              {/* 投资协议---我的项目 */}
              <Route
                exact
                path={`${match.path}/myProject/agreement/:projectId`}
                component={InvestAgreement}
              />
              {/* 投资份额---我的项目 */}
              {/* <Route
                exact
                path={`${match.path}/myProject/share/:purchaseId`}
                component={InvestShare}
              /> */}

              {/* 转让列表 */}
              <Route
                exact
                path={`${match.path}/transferList`}
                component={TransferList}
              />

              {/* 回收记录 */}
              <Route
                exact
                path={`${match.path}/repurchaseList`}
                component={RepurchaseList}
              />

              {/* 出售记录 */}
              <Route
                exact
                path={`${match.path}/sellList`}
                component={SellList}
              />

              {/* 开票记录 */}
              <Route
                exact
                path={`${match.path}/ticketList`}
                component={TicketList}
              />

              {/* 我的企业 */}
              <Route
                exact
                path={`${match.path}/myEnterprise`}
                component={MyEnterprise}
              />

              <Route
                exact
                path={`${match.path}/myEnterprise/addEnterprise/:id`}
                component={EnterpriseForm}
              />
              {/* 关于我们 */}
              <Route path={`${match.path}/aboutUs`} component={AboutUs} />
              {/* 账户中心 */}
              <Route exact path={`${match.path}/accountCenter`} component={AccountCenter} />
              <Route exact path={`${match.path}/accountCenter/recharge`} component={Recharge} />
              <Route exact path={`${match.path}/accountCenter/rechargeCallBack`} component={RechargeCallBack} />

            </Switch>
          </div>
        </div>
      </div>
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/layout/Layout.js